import { PartImageReadText } from '@/api/generatedApi';

const READ_TEXT_LABELS: Record<string, string> = {
  nsn: 'NSN',
  niin: 'NIIN',
  'part-number': 'P/N',
  cage: 'CAGE',
  manufacturer: 'MFR',
  model: 'MODEL',
};

export const readTextLabel = ({ kind, text }: PartImageReadText): string => {
  const prefix = READ_TEXT_LABELS[kind] ?? kind.toUpperCase();
  return text.toUpperCase().startsWith(prefix) ? text : `${prefix} ${text}`;
};
